import React, { Fragment } from "react";
import partnersBanner from "assets/images/YOOZ-STORIES-BANNER.png";
import ContentWrapper from "components/public-dashboard/components/contentWrapper";
import PageBanner from "components/public-dashboard/components/page_banner";
import PartnersReviewContent from "./content";
import PartnersReviewHeader from "./header";
import useDocumentTitle from "../../../../../hooks/useDocumentTitle";
import Button from "@material-ui/core/Button";
import {Link as RouterLink} from "react-router-dom";

export default function PartnerCaseStudy() {


  useDocumentTitle("Partners");
  return (
    <Fragment>
      <PageBanner img={partnersBanner} />
      <ContentWrapper>
        <PartnersReviewContent />

      </ContentWrapper>
    </Fragment>
  );
}
